export default __webpack_public_path__ + "static/media/M.2.3.8dbc717c.svg";